import { render } from "./DadosFinanceiros.vue?vue&type=template&id=6316be96&scoped=true"
import script from "./DadosFinanceiros.vue?vue&type=script&lang=js"
export * from "./DadosFinanceiros.vue?vue&type=script&lang=js"

import "./DadosFinanceiros.vue?vue&type=style&index=0&id=6316be96&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6316be96"]])

export default __exports__